import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
/**
 * A segmented control where each button has only an icon.
 *
 * @see Selector in design-system for a similar full-width component
 */
const IconSegmentedControl = ({ value, onValueChange, values, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      {values.map((item, index) => {
            const selected = item.value === value;
            return (<TouchableBounce key={item.value.toString()} onPress={() => {
                    onValueChange(item.value, index);
                }} style={[
                    styles.iconContainer,
                    {
                        backgroundColor: selected ? colors.cards.onDark : undefined,
                    },
                ]}>
            <item.IconComponent color={selected
                    ? colors.elements.secondary
                    : colors.elements.secondaryTransparentFill} width={24} height={24}/>
          </TouchableBounce>);
        })}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        padding: rem(4),
        alignItems: 'center',
        gap: rem(2),
        borderRadius: rem(13),
        backgroundColor: colors.background.dark,
        alignSelf: 'flex-start',
    },
    iconContainer: {
        padding: rem(8),
        borderRadius: rem(8),
    },
}));
export default React.memo(IconSegmentedControl);
